import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { useTrans } from "../../../../hooks";
import { FormValidation } from "../FormValidation";
import { requiredField } from "../helpers";
import {
  MAP_WATTYS_AWARD_CATEGORIES,
  MAP_WATTYS_AWARD_CATEGORIES_NON_ENGLISH
} from "../constants";
import ContestFormField from "../ContestFormField";
import ErrorField from "./ErrorField";

const PrimaryGenreIdentificationField = ({
  form,
  onFormChange,
  fieldStatus,
  submitted,
  storyLanguage
}) => {
  const { trans } = useTrans();

  const title = trans("Awards category declaration");

  const subtitle = (
    <div className="subtitle">
      <div
        dangerouslySetInnerHTML={{
          __html: /* prettier-ignore */ trans('You are submitting your story in the award category listed below based on the primary genre selected for this story. To change the primary genre your story is written in, please make any necessary edits in your story settings.')
        }}
      />
      <br />
      <div
        dangerouslySetInnerHTML={{
          __html: /* prettier-ignore */ trans("<strong>Romance (Mature):</strong> Any Romance story with a Mature rating.")
        }}
      />
      <br />
      <div
        dangerouslySetInnerHTML={{
          __html: /* prettier-ignore */ trans("<strong>Romance (Non-Mature):</strong> Any Romance story with a For Everyone rating.")
        }}
      />
      <br />
      <div
        dangerouslySetInnerHTML={{
          __html: /* prettier-ignore */ trans("<strong>Speculative Fiction:</strong> Fantasy, Science Fiction, Paranormal, and Horror.")
        }}
      />
      <br />
      <div
        dangerouslySetInnerHTML={{
          __html: /* prettier-ignore */ trans("<strong>Mystery, Action & Thriller:</strong> Mystery, Action & Thriller.")
        }}
      />
      <br />
      <div
        dangerouslySetInnerHTML={{
          __html: /* prettier-ignore */ trans("<strong>Wildcard:</strong> Culture & Identity, Historical, LGBTQIA+, Social Themes and any other genre-bending fiction.")
        }}
      />
    </div>
  );

  const errorCondition =
    (fieldStatus.fieldInvalid ||
      (fieldStatus.fieldName !== "genrePrimary" &&
        fieldStatus.fieldName !== "" &&
        submitted)) &&
    form.genrePrimary === "";

  const isEnglish =
    storyLanguage === "English" && parseInt(app.get("language"), 10) === 1;
  const genres = isEnglish
    ? MAP_WATTYS_AWARD_CATEGORIES
    : MAP_WATTYS_AWARD_CATEGORIES_NON_ENGLISH;

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <FormValidation validationRules={[requiredField(trans)]}>
        {({ ref, errorMessage, className }) => (
          <React.Fragment>
            <select
              ref={ref}
              id="primary-genre-identification-select"
              value={form.genrePrimary}
              name="genrePrimary"
              disabled
              className={classNames("form-element", className)}
              onChange={onFormChange}
              aria-label={
                genres(trans).find(genre => genre.key === form.genrePrimary)
                  ?.value
              }
            >
              <option value="" disabled>
                {trans("Select an option")}
              </option>
              {genres(trans).map(category => (
                <option key={category.key} value={category.key}>
                  {category.value}
                </option>
              ))}
            </select>
            <ErrorField
              errorMessage={errorMessage}
              fieldId={"primary-genre-identification"}
            />
            {!errorMessage && (
              <ErrorField
                fieldId={"primary-genre-identification"}
                errorCondition={errorCondition}
              />
            )}
          </React.Fragment>
        )}
      </FormValidation>
    </ContestFormField>
  );
};

PrimaryGenreIdentificationField.propTypes = {
  form: PropTypes.object.isRequired,
  onFormChange: PropTypes.func.isRequired,
  fieldStatus: PropTypes.shape({
    fieldInvalid: PropTypes.bool,
    fieldName: PropTypes.string
  }).isRequired,
  submitted: PropTypes.bool.isRequired,
  storyLanguage: PropTypes.string
};

export default PrimaryGenreIdentificationField;
